import { EDITING_TRACK_TYPE, getTrackDisplayName, getTrackFlights } from "./trackUtils";

export function getAgentAdoptTargetFlightCount(targetTrack) {
    return getTrackFlights(targetTrack).length;
}

export function getAgentAdoptDirtyBlockReason({ flightDirtyState, compareDirtyState } = {}) {
    const dirtyLabels = [
        flightDirtyState?.isDirty ? "航班修改" : null,
        compareDirtyState?.isDirty ? "Compare 修改" : null,
    ].filter(Boolean);

    if (!dirtyLabels.length) {
        return "";
    }

    return `请先保存或放弃${dirtyLabels.join("和")}后再追加采纳 Agent 方案。`;
}

export function getAgentAdoptBlockedReason({
    draftId,
    agentTrack,
    targetTrack,
    hasUpdatePermission = true,
    isAgentWorking = false,
    flightDirtyState,
    compareDirtyState,
} = {}) {
    if (!draftId) {
        return "缺少草稿 ID，无法采纳 Agent 方案。";
    }
    if (!agentTrack?.id) {
        return "缺少 Agent 方案轨，无法采纳。";
    }
    if (!hasUpdatePermission) {
        return "缺少 schedule:update 权限，无法采纳 Agent 方案。";
    }
    if (isAgentWorking) {
        return "Agent 执行期间不可采纳方案，请等待当前任务结束。";
    }

    const dirtyBlockReason = getAgentAdoptDirtyBlockReason({ flightDirtyState, compareDirtyState });
    if (dirtyBlockReason) {
        return dirtyBlockReason;
    }

    if (!targetTrack?.id) {
        return "缺少目标编辑轨，无法采纳 Agent 方案。";
    }
    if (targetTrack.track_type !== EDITING_TRACK_TYPE || targetTrack.is_editable === false) {
        return "目标轨必须是可编辑的编辑轨。";
    }

    return "";
}

export function buildAgentAdoptConfirmLines({ targetTrack, targetFlightCount = getAgentAdoptTargetFlightCount(targetTrack) } = {}) {
    const targetName = getTrackDisplayName(targetTrack);
    const lines = [
        `将 Agent 方案航班追加克隆到「${targetName}」。`,
        "当前后端不会替换或清空目标轨既有航班。",
    ];

    if (targetFlightCount > 0) {
        lines.push(`目标编辑轨已有 ${targetFlightCount} 个航班，当前版本尚未提供替换/合并选择；继续追加可能产生重复航班。`);
    } else {
        lines.push("目标编辑轨当前没有航班，继续后会追加 Agent 方案全部航班。");
    }

    return lines;
}

export function buildAgentAdoptPayload(targetTrack) {
    return targetTrack?.id ? { target_track_id: targetTrack.id } : {};
}
